import React from 'react'
import PropTypes from 'prop-types'
import { ParentRelationshipCreator } from '@leverege/api-attributes'
import { Button, PropertyGrid, Text } from '@leverege/ui-elements'
import { ApiProvider } from '@leverege/api-redux'
import classNames from 'classnames'
import Loading from '../../views/Loading'

import S from './ParentRelationshipEditor.css'

export default class ParentRelationshipEditor extends React.Component {

  static TYPE = ParentRelationshipCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  static contextType = ApiProvider.Context

  constructor( props ) {
    super( props )
    this.state = {
      starParent : undefined,
      loading : false,
      error : null,
    }
  }

  componentDidMount() {
    const { attribute, device } = this.props
    if ( attribute && device ) {
      this.fetchStarParent()
    }
  }

  async fetchStarParent() {
    const { attribute, device } = this.props
    const api = this.context

    this.setState( { loading : true } )
    
    let res
    try {
      res = await api.interface( device.systemId, attribute.sourceBlueprintId )
        .obj( '*' ).grp( attribute.parentPath ).obj( device.id )
        .get()
      if ( res?.items?.[0] ) {
        let shortest = null
        Object.entries( res?.items?.[0] ).forEach(
          ( [ path, deviceId ] ) => {
            if ( shortest === null || path.length < shortest.path ) {
              shortest = { path, deviceId }
            }
          }
        )
        this.setState( {
          loading : false,
          starParent : shortest.deviceId
        } )
      } else {
        this.setState( {
          loading : false,
          starParent : null
        } )
      }
    } catch ( error ) {
      this.setState( { error, loading : false } )
    }
  }

  resync = () => {
    const { onChange, attribute, value } = this.props
    const { starParent, error } = this.state
    if ( starParent !== undefined && error == null ) {
      const update = []
      if ( starParent == null ) {
        update.push( { path : attribute.path, value : null } )
      } else {
        update.push( { path : `${attribute.path}/id`, value : starParent } )
        if ( value?.time == null && starParent !== value?.id ) {
          update.push( { path : `${attribute.path}/time`, value : Date.now() } )
        }
      }
      onChange( { value : update, override : true } )
    }
  }
  
  render() {
    const { attribute : attr, value } = this.props
    const { error, loading, starParent } = this.state
    if ( attr == null || !attr.relationshipType.startsWith( 'oneTo' ) ) {
      return <div />
    }
    if ( loading ) {
      return <Loading show message="Loading Parent Id" />
    }

    if ( error ) {
      return (
        <Text variant="error">{error.message}</Text>
      )
    }

    return (
      <PropertyGrid vertical className={classNames( S.container, S.override )}>
        <PropertyGrid.Item label="Value in Realtime Data">
          <Text variant="bodySmallBold">{value?.id || '(empty)'}</Text>
        </PropertyGrid.Item>
        <PropertyGrid.Item label="Value in Relationship DB">
          <Text variant="bodySmallBold">{starParent || '(empty)'}</Text>
        </PropertyGrid.Item>
        <PropertyGrid.Item>
          <Button variant="secondary" disabled={starParent === undefined} onClick={this.resync}>Resync</Button>
        </PropertyGrid.Item>
      </PropertyGrid>
    )
  }
}
